import { User, UserPreferences, UserTheme, DashboardLayout } from '../models/user.model';

export const MOCK_USERS: User[] = [
  {
    id: 1,
    username: 'admin',
    email: 'admin@sunsetgardens.com',
    firstName: 'John',
    firstNameKey: 'users.john',
    lastName: 'Admin',
    lastNameKey: 'users.admin',
    phone: '+1-555-0001',
    avatar: 'https://example.com/avatars/admin.jpg',
    isActive: true,
    isEmailVerified: true,
    lastLoginDate: new Date('2024-01-17T08:30:00Z'),
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-17T08:30:00Z'),
    roleId: 1,
    preferences: {
      id: 1,
      userId: 1,
      language: 'en',
      timezone: 'America/New_York',
      theme: UserTheme.LIGHT,
      emailNotifications: true,
      smsNotifications: true,
      pushNotifications: true,
      dashboardLayout: DashboardLayout.GRID,
      dateFormat: 'MM/DD/YYYY',
      timeFormat: '12h',
      currency: 'USD',
    },
    twoFactorEnabled: true,
  },
  {
    id: 2,
    username: 'manager1',
    email: 'manager@sunsetgardens.com',
    firstName: 'Sarah',
    firstNameKey: 'users.sarah',
    lastName: 'Manager',
    lastNameKey: 'users.manager',
    phone: '+1-555-0002',
    avatar: 'https://example.com/avatars/manager.jpg',
    isActive: true,
    isEmailVerified: true,
    lastLoginDate: new Date('2024-01-16T14:20:00Z'),
    createdDate: new Date('2021-03-10T00:00:00Z'),
    updatedDate: new Date('2024-01-16T14:20:00Z'),
    roleId: 2,
    preferences: {
      id: 2,
      userId: 2,
      language: 'en',
      timezone: 'America/New_York',
      theme: UserTheme.DARK,
      emailNotifications: true,
      smsNotifications: false,
      pushNotifications: true,
      dashboardLayout: DashboardLayout.LIST,
      dateFormat: 'DD/MM/YYYY',
      timeFormat: '24h',
      currency: 'USD',
    },
    twoFactorEnabled: false,
  },
  {
    id: 3,
    username: 'john.smith',
    email: 'john.smith@email.com',
    firstName: 'John',
    firstNameKey: 'users.john-smith',
    lastName: 'Smith',
    lastNameKey: 'users.smith',
    phone: '+1-555-0101',
    avatar: 'https://example.com/avatars/john-smith.jpg',
    isActive: true,
    isEmailVerified: true,
    lastLoginDate: new Date('2024-01-15T16:45:00Z'),
    createdDate: new Date('2023-06-15T00:00:00Z'),
    updatedDate: new Date('2024-01-15T16:45:00Z'),
    roleId: 3,
    residentId: 1,
    preferences: {
      id: 3,
      userId: 3,
      language: 'en',
      timezone: 'America/New_York',
      theme: UserTheme.LIGHT,
      emailNotifications: true,
      smsNotifications: true,
      pushNotifications: true,
      dashboardLayout: DashboardLayout.GRID,
      dateFormat: 'MM/DD/YYYY',
      timeFormat: '12h',
      currency: 'USD',
    },
    twoFactorEnabled: false,
  },
  {
    id: 4,
    username: 'maria.garcia',
    email: 'maria.garcia@email.com',
    firstName: 'Maria',
    firstNameKey: 'users.maria',
    lastName: 'Garcia',
    lastNameKey: 'users.garcia',
    phone: '+1-555-0201',
    avatar: 'https://example.com/avatars/maria-garcia.jpg',
    isActive: true,
    isEmailVerified: true,
    lastLoginDate: new Date('2024-01-14T11:30:00Z'),
    createdDate: new Date('2023-08-20T00:00:00Z'),
    updatedDate: new Date('2024-01-14T11:30:00Z'),
    roleId: 3,
    residentId: 2,
    preferences: {
      id: 4,
      userId: 4,
      language: 'es',
      timezone: 'America/New_York',
      theme: UserTheme.DARK,
      emailNotifications: true,
      smsNotifications: false,
      pushNotifications: true,
      dashboardLayout: DashboardLayout.COMPACT,
      dateFormat: 'DD/MM/YYYY',
      timeFormat: '24h',
      currency: 'USD',
    },
    twoFactorEnabled: false,
  },
  {
    id: 5,
    username: 'mike.rodriguez',
    email: 'mike@eliteplumbing.com',
    firstName: 'Mike',
    firstNameKey: 'users.mike',
    lastName: 'Rodriguez',
    lastNameKey: 'users.rodriguez',
    phone: '+1-555-1001',
    avatar: 'https://example.com/avatars/mike-rodriguez.jpg',
    isActive: true,
    isEmailVerified: true,
    lastLoginDate: new Date('2024-01-13T09:15:00Z'),
    createdDate: new Date('2023-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-13T09:15:00Z'),
    roleId: 4,
    vendorId: 1,
    preferences: {
      id: 5,
      userId: 5,
      language: 'en',
      timezone: 'America/New_York',
      theme: UserTheme.AUTO,
      emailNotifications: true,
      smsNotifications: true,
      pushNotifications: false,
      dashboardLayout: DashboardLayout.LIST,
      dateFormat: 'MM/DD/YYYY',
      timeFormat: '12h',
      currency: 'USD',
    },
    twoFactorEnabled: true,
  },
];
